import { render, staticRenderFns } from "./HistoryStorageOverview.vue?vue&type=template&id=05c636d3"
import script from "./HistoryStorageOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryStorageOverview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports